import React, { Component } from 'react';

export class Gallery extends Component {
  static displayName = Gallery.name;

  constructor(props) {
    super(props);
    this.state = {
      activeTab: "all",

      showModal: false,
      modalType: null, // photo | video | youtube
      modalSrc: null,
      modalVideoId: null,

      galleryData: [
        // ----- PHOTOS -----
        { id: 1, type: "photo", src: "/images/Gallary_Image1.jpg", title: "Swami Brahmanand Saraswati" },
        { id: 2, type: "photo", src: "/images/Gallary_Image2.jpg", title: "Mahakaleshwar Aashram" },
        { id: 3, type: "photo", src: "/images/Gallary_Image3.jpg", title: "Aacharya Sudhir Bhardwaj" },
        { id: 4, type: "photo", src: "/images/Gallary_Image4.jpg", title: "Dipankar Maharaj" },
        { id: 5, type: "photo", src: "/images/Gallary_Image5.jpg", title: "Premanand Maharaj" },
        { id: 6, type: "photo", src: "/images/Gallary_Image6.jpg", title: "Ankit Pandit Ji" },
        { id: 7, type: "photo", src: "/images/Gallary_Image11.jpg", title: "Swami Vinodanand Saraswati" },
        { id: 8, type: "photo", src: "/images/Gallary_Image8.jpg", title: "Swami Brahmanand Saraswati" },
        { id: 9, type: "photo", src: "/images/Gallary_Image14.jpg", title: "Swami Vinodanand Saraswati" },
        { id: 10, type: "photo", src: "/images/Gallary_Image9.jpg", title: "Maa Bala Sundri Mandir" },
        { id: 11, type: "photo", src: "/images/Gallary_Image13.jpg", title: "Swami Brahmanand Saraswati" },
        { id: 12, type: "photo", src: "/images/Gallary_Image10.jpg", title: "Maa Bala Sundri Mandir" },
        { id: 13, type: "photo", src: "/images/Gallary_Image7.jpg", title: "Makaleshwar Aashram" },
        { id: 14, type: "photo", src: "/images/Gallary_Image12.jpg", title: "Swami Brahmanand Saraswati" },
        { id: 15, type: "photo", src: "/images/Gallary_Image21.jpg", title: "Swami Brahmanand Saraswati" },
        { id: 16, type: "photo", src: "/images/Gallary_Image22.jpg", title: "Swami Brahmanand Saraswati" },
        { id: 17, type: "photo", src: "/images/Gallary_Image23.jpg", title: "Swami Brahmanand Saraswati" },
        { id: 18, type: "photo", src: "/images/Gallary_Image24.jpg", title: "Swami Brahmanand Saraswati" },
        { id: 19, type: "photo", src: "/images/Gallary_Image25.jpg", title: "Swami Brahmanand Saraswati" },
        { id: 20, type: "photo", src: "/images/Gallary_Image26.jpg", title: "Swami Brahmanand Saraswati" },

        // ----- LOCAL VIDEO -----
        { id: 21, type: "video", src: "/videos/video1.mp4", title: "Ashram Video" },

        // ----- YOUTUBE VIDEO -----
        { id: 22, type: "youtube", videoId: "yqkPwRaw3Nw", title: "Swami Brahmanand Saraswati Ji Maharaj"},
        { id: 23, type: "youtube", videoId: "fyiLTEIDRyI", title: "Swami Brahmanand Saraswati"},
        { id: 24, type: "youtube", videoId: "uk4-WLtlwC0", title: "महाकाली की जीवित चेतना"},
        { id: 25, type: "youtube", videoId: "Vr7mXpCE7lA", title: "स्वामी ब्रह्मानंद सरस्वती जी महाराज बनें संतों के लिए प्रेरणा स्रोत"},
        { id: 26, type: "youtube", videoId: "QnpJT3_dUH0", title: "Maa Baglamukhi ke Param Upasak"}
      ]
    };
  }
  
  setTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  openModal = (item) => {
    this.setState({
      showModal: true,
      modalType: item.type,
      modalSrc: item.src || null,
      modalVideoId: item.videoId || null
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      modalType: null,
      modalSrc: null,
      modalVideoId: null
    });
  };

  render() {
    const {
      activeTab,
      galleryData,
      showModal,
      modalType,
      modalSrc,
      modalVideoId
    } = this.state;

    const filteredGallery =
      activeTab === "all"
        ? galleryData
        : activeTab === "photo"
        ? galleryData.filter(item => item.type === "photo")
        : galleryData.filter(item => item.type !== "photo");

    return (
      <>
        <section className="gallery-section container">

          {/* ---------- TABS ---------- */}
          <div className="gallery-tabs">
            <button className={activeTab === "all" ? "active" : ""} onClick={() => this.setTab("all")}>All</button>
            <button className={activeTab === "photo" ? "active" : ""} onClick={() => this.setTab("photo")}>Photos</button>
            <button className={activeTab === "video" ? "active" : ""} onClick={() => this.setTab("video")}>Videos</button>
          </div>

          {/* ---------- GRID ---------- */}
          <div className="gallery-grid">
            {filteredGallery.map(item => (
              <div
                className="gallery-item"
                key={item.id}
                onClick={() => this.openModal(item)}
              >

                {item.type === "photo" && (
                  <img src={item.src} alt={item.title} />
                )}

                {item.type === "video" && (
                  <div className="video-thumb">
                    <video src={item.src} muted />
                    <span className="play-btn">▶</span>
                  </div>
                )}

                {item.type === "youtube" && (
                  <div className="youtube-thumb">
                    <img
                      src={`https://img.youtube.com/vi/${item.videoId}/hqdefault.jpg`}
                      alt={item.title}
                    />
                    <span className="play-btn">▶</span>
                  </div>
                )}

                <div className="overlay">{item.title}</div>
              </div>
            ))}
          </div>
        </section>

        {/* ---------- MODAL ---------- */}
        {showModal && (
          <div className="media-modal" onClick={this.closeModal}>
            <div className="media-box" onClick={e => e.stopPropagation()}>

              {modalType === "photo" && (
                <img src={modalSrc} alt="Large View" />
              )}

              {modalType === "video" && (
                <video src={modalSrc} controls autoPlay />
              )}

              {modalType === "youtube" && (
                <iframe
                  src={`https://www.youtube.com/embed/${modalVideoId}?autoplay=1`}
                  title="YouTube"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                ></iframe>
              )}

              <button className="close-btn" onClick={this.closeModal}>✕</button>
            </div>
          </div>
        )}
      </>
    );
  }
}
